import React from 'react';

export default function RightPanel({ 
  totalWin = 0, 
  denomination = 0.05, 
  bets = {}, 
  credit = 100, 
  cardSelections = {},
  onResetSession,
  onStartAutoSession,
  onStopAutoSession,
  onContinueAutoSession,
  sessionGamesPlayed = 0,
  sessionTotalWon = 0,
  sessionTotalWagered = 0,
  isAutoSession = false,
  autoSessionRemaining = 0,
  autoSessionTotal = 0,
  showContinueButton = false,
    allowBackgroundSessions = false,
    setAllowBackgroundSessions,
  isPremium = false,
  freeGameLimit = 25,
}) {
  // Calculate if there is enough credit to start a game
  const totalBetCredits = Object.values(bets).reduce((sum, bet) => sum + bet, 0);
  const hasMarkedCard = Object.keys(bets).some(card => (bets[card] || 0) > 0 && (cardSelections?.[card]?.length || 0) >= 2);
  const totalWager = totalBetCredits * denomination;
  const insufficientCredit = totalWager > credit || totalWager === 0 || !hasMarkedCard;
  const formatCurrency = (value) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };
  // Removed unused variables: currentGameWin, cardsPlayed, currentBet

    // ...existing code...

  return (
    <aside className="right-panel">

<div 
  style={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    marginBottom: '6px',
    marginTop: '0px',
    padding: '0px',
    borderRadius: '0px',
    gap: '10px',
    background: 'transparent' // Light background for the header area
  }}
>
  <h3 className="panel-title" style={{ marginTop: 0, marginBottom: 0,marginLeft: 4 }}>
    AUTO SESSION
  </h3>

    <label 
        title={!isPremium ? 'Premium feature — upgrade to enable background sessions' : 'When enabled, sessions will continue to run even if the browser tab is not active. This allows you to switch to other tabs or applications without interrupting your session. Note: Enabling this may increase resource usage and could lead to higher battery consumption on laptops.'}
    style={{ 
    display: 'flex', 
    alignItems: 'center', 
    fontSize: '0.85rem',
    cursor: isPremium ? 'pointer' : 'not-allowed',
    userSelect: 'none',
    // New styles added below:
    border: '1px solid #8b8585', // Sets the 1px border
    background: isPremium ? '#fad56e' : '#ccc', // Light background color for contrast
    padding: '2px 6px',      // Adds space between the border and content
    borderRadius: '4px',      // Rounds the corners of the box
    width: 'fit-content'      // Keeps the box tight around the text
  }}
>
  <input
    type="checkbox"
    checked={allowBackgroundSessions}
    onChange={(e) => isPremium && setAllowBackgroundSessions(e.target.checked)}
    disabled={!isPremium}
    style={{ marginRight: '6px', cursor: isPremium ? 'pointer' : 'not-allowed' }}
  />
  Allow background sessions{!isPremium && <span style={{ marginLeft: '4px', fontSize: '0.75rem', color: '#888' }}>★</span>}
</label>

</div>

      <div className="rp-horizontal-container" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', alignItems: 'stretch' }}>

        <div style={{ display: 'contents' }}>
          <div className="rp-section" style={{ minWidth: 0, gridColumn: 1, paddingLeft: '5px' }}>
            <div className="rp-stat">
              <span className="rp-key">Session Counter:</span>
              <span className="rp-value" style={{ color: isAutoSession ? '#007bff' : (autoSessionTotal > 0 ? '#28a745' : '#666'), fontWeight: (isAutoSession || autoSessionTotal > 0) ? 'bold' : 'normal' }}>
                {autoSessionTotal > 0 ? `${autoSessionRemaining} / ${autoSessionTotal}` : '-'}
              </span>
            </div>
            <div className="rp-stat">
              <span className="rp-key">Total Games Played:</span>
              <span className="rp-value" style={!isPremium && sessionGamesPlayed >= freeGameLimit ? { color: '#dc3545', fontWeight: 'bold' } : {}}>
                {sessionGamesPlayed}{!isPremium ? ` / ${freeGameLimit}` : ''}
              </span>
            </div>
            <div className="rp-stat">
              <span className="rp-key">Wager per Game:</span>
              <span className="rp-value">{formatCurrency(Object.values(bets).reduce((sum, bet) => sum + bet, 0) * denomination)}</span>
            </div>
          </div>
          {/* Divider removed for cleaner layout */}
          <div className="rp-section" style={{ minWidth: 0, gridColumn: 2, paddingRight: '5px' }}>
            <div className="rp-stat">
              <span className="rp-key">Total Wagered:</span>
              <span className="rp-value">{formatCurrency(sessionTotalWagered)}</span>
            </div>
            <div className="rp-stat">
              <span className="rp-key">Total Won:</span>
              <span className="rp-value">{formatCurrency(sessionTotalWon)}</span>
            </div>
            <div className="rp-stat">
              <span className="rp-key">Net Profit/Loss:</span>
              <span className="rp-value" style={{ fontWeight: 'bold', color: sessionTotalWon - sessionTotalWagered >= 0 ? '#28a745' : '#dc3545' }}>
                {formatCurrency(sessionTotalWon - sessionTotalWagered)}
              </span>
            </div>
          </div>
        </div>
      </div>
    <div
  style={{
    display: 'flex',
    justifyContent: 'center',
    gap: '18px',
    marginTop: '4px',
    marginBottom: '0px',
  }}
>
  {/* Reset Session */}
  <button
    className="new-session-btn"
    onClick={onResetSession}
    style={{ width: '160px' }}
  >
    Reset Session Totals
  </button>

  {/* Continue Auto Session — now in the middle */}
  <button
    className="new-session-btn"
    onClick={onContinueAutoSession}
    style={{
      width: '160px',
      backgroundColor: '#28a745',
      color: 'yellow',
      border: '1px solid black',
      fontWeight: '600',
      visibility:
        showContinueButton && !isAutoSession && autoSessionRemaining > 0
          ? 'visible'
          : 'hidden',
    }}
    disabled={insufficientCredit}
    title={insufficientCredit ? 'Insufficient credit or invalid bet' : ''}
  >
    Continue Auto Session
  </button>

  {/* New / Stop Auto Session */}
  <button
    className="new-session-btn"
    onClick={isAutoSession ? onStopAutoSession : onStartAutoSession}
    style={{
      width: '160px',
      backgroundColor: isAutoSession ? '#dc3545' : '#28a745',
      color: 'yellow',
      border: '1px solid black',
      fontWeight: '600',
    }}
    disabled={!isAutoSession && insufficientCredit}
    title={!isAutoSession && insufficientCredit ? 'Insufficient credit or invalid bet' : ''}
  >
    {isAutoSession ? 'Stop Auto Session' : 'New Auto Session'}
  </button>
</div>
    </aside>
  );
}
